import request from '@/utils/request';
export function getGateUserMangList(data) {
  return request({
    url: '/order/gate_user_list',
    method: 'get',
    params: data
  });
}